import React from "react";
import {Card} from "antd";
import { DashboardLayout } from "../../layout";
import { NavigationTabs, CalendarBox, ScoreBox } from "./components";


const LiveScores = () => {
  return (
    <DashboardLayout page="livescores">
      <div className="hidden lg:block">
        <NavigationTabs />
        <div className="mt-10">
          <CalendarBox />
        </div>
        <div className="mt-10">
          <Card style={{padding: 20, borderRadius: 10}}>
            <ScoreBox />
            <ScoreBox />
          </Card>
        </div>
      </div>
      <div className="mt-5 hidden lg:block">
        
      </div>
      <div className="mt-0 lg:mt-5">
        
      </div>
    </DashboardLayout>
  );
};

export default LiveScores;
